export enum UploadStatus {
  SUCCESS,
  UPLOAD_FAILURE,
  UPLOAD_ISSUES,
}
